export default __webpack_public_path__ + "static/media/mark-as-unresolved-sign.9363ae7c.svg";